import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Modal, Button } from 'carbon-components-react';
import StepCard from '../../StepCard';
import PlusSvg from '../../Icons/PlusSvg';
import ItensMerchandisig from './ItensMerchandisig';

class Merchandising extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      observacao: null,
      materials: (props.data && props.data.produtos) || [],
      selecteds: [],
      salvouMerchandising: false,
    };
  }

  renderDescription = () => {
    const { step, data } = this.props;
    const { materials } = this.state;
    if (data) {
      return (
        <div className="font-size-13" style={{ color: '#36474f' }}>
          {materials && materials.map((item, index) => (
            <div key={item}>
              <strong>
                {item.nome}
                {index + 1 < materials.length ? ',' : ''}
                {' '}
              </strong>
            </div>
          ))}
        </div>
      );
    }

    return step.description;
  };

  OpenModal = () => {
    this.removeBorderOrange();
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen,
    }));
  };

  onSelect = () => {
    this.setState(
      prevState => ({
        ...prevState,
        materials: [...prevState.materials, ...prevState.selecteds],
        selecteds: [],
      }),
      () => {
        this.OpenModal();
      },
    );
  };

  cancelIntes = () => {
    const { selecteds } = this.state;
    selecteds.forEach((item) => {
      this.setState(
        (prevState) => {
          const list = [...prevState.materials];
          const idx = list.indexOf(item);
          list.splice(idx, 1);
          return {
            materials: list,
            selecteds: [],
          };
        },
        () => {
          this.save();
        },
      );
    });

    this.OpenModal();
  };

  cancel = () => {
    const { selectedValue } = this.props;
    this.setState({ selectedValue });
    this.stepCardRef.toggleContent();
  };

  save = async () => {
    const { materials } = this.state;
    const { saveStep, selectedValue } = this.props;

    if(materials.length){
      await saveStep({
        salvouMerchandising: true,
        lstProdutos: materials
      });
      this.setState({ selectedValue });
      await this.stepCardRef.toggleContent();
    }else{
      toast.warn("Você precisa  selecionar os materiais");
    }
    

  };

  makeItem = (item) => {
    const material = {
      id: item.id,
      idProduto: item.id,
      nome: item.nome,
    };

    const figure = document.getElementById(`itemImg${item.id}`).classList;

    if (figure.contains('border-orange')) {
      figure.remove('border-orange');
      this.setState((prevState) => {
        const list = [...prevState.materials];
        const idx = list.indexOf(material);
        list.splice(idx, 1);
        return {
          selecteds: list,
        };
      });
    } else {
      figure.add('border-orange');
      this.setState(prevState => ({
        selecteds: [...prevState.selecteds, material],
      }));
    }
  };

  removeItem = (item) => {
    const { buttonIn } = this.props;
    this.setState(
      (prevState) => {
        const list = [...prevState.materials];
        const idx = list.indexOf(item);
        list.splice(idx, 1);
        return {
          materials: list,
        };
      },
      () => {
        if (!buttonIn) {
          this.save();
          this.setState(prevState => ({
            salvouMerchandising: prevState.materials.length,
          }));
        }
      },
    );
  };

  toggleMerchandising = () => {
    this.save();
    this.setState(prevState => ({
      salvouMerchandising: !prevState.salvouMerchandising,
    }));
  };

  removeBorderOrange = () => {
    const allElements = Array.from(document.querySelectorAll('.figure-img'));
    for (const element of allElements) {
      element.classList.remove('border-orange');
    }
  };

  render() {
    const { step, buttonIn, isStore } = this.props;
    const { modalOpen, materials } = this.state;
    const validate = true;
    const finished = materials.length ? validate : !validate;
    console.log("merchandis")
    console.log(this.props)
    return (
      <StepCard
        onRef={(ref) => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        onButtonClick={this.toggleMerchandising}
        isFinished={finished}
        disabled={isStore}
      >
        <div className="bx--row">
          <div className="bx--col-xs-12 mg-top-20">
            <a className="link-dm pointer" onClick={() => this.OpenModal()}>
              <PlusSvg />
              {' '}
              Adicionar item
            </a>
          </div>
          <div className="bx--col-xs-12">
            {materials.map(item => (
              <div key={item} className="item-selecionado">
                {item.nome}
                {' '}
                <span className="icon-remove" onClick={() => this.removeItem(item)}>
                  {' '}
                  <svg width="16" height="16" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM4 7v2h8V7H4z" />
                  </svg>
                </span>
              </div>
            ))}
          </div>
          <Modal
            onRequestSubmit={() => this.onSelect()}
            onRequestClose={() => this.cancelIntes()}
            iconDescription="Fechar"
            className="merchandisig-modal"
            open={modalOpen}
            modalHeading="Itens"
            primaryButtonText="Selecionar"
            secondaryButtonText="Cancelar"
          >
            <div className="box-galery-itens">
              <ItensMerchandisig makeItem={this.makeItem} cancelItens={this.cancelItens} />
            </div>
          </Modal>
        </div>
        {buttonIn && (
          <div className="bx--row">
            <div className="bx--col-md-12">
              <br />
              {' '}
              <br />
              <div className="v-md-margin mg-top-40">
                <Button 
                  onClick={this.save}
                  disabled={!materials.length}
                >
                  Avançar
                </Button>
                <Button 
                  kind="ghost" 
                  className="h-sm-margin" 
                  onClick={this.cancel}                  
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        )}
      </StepCard>
    );
  }
}

export default Merchandising;



// WEBPACK FOOTER //
// ./src/components/trades/campaign/Merchandising.js